<template>
  <div class="space-y-3">
    <div class="space-y-1">
      <p class="label is-required">Eligible statements</p>
      <p class="text-xs text-gray-600">
        Move the selected reservation to a statement that uses the same funding source.
      </p>
    </div>

    <div class="space-y-4">
      <button
        class="btn btn-link"
        @click="emit('click:back')"
      >
        <app-icon
          size="sm"
          name="arrow-narrow-left"
        />
        Back to eligible statements
      </button>

      <app-card
        variant="muted"
        body-class="space-y-3 p-4 text-sm"
      >
        <p class="font-semibold">New statement</p>
        <ul class="list-disc space-y-1 pl-4">
          <li>
            <div class="flex items-center justify-between gap-2">
              <span class="text-gray-600">Supplier</span>
              <app-badge size="sm">{{ statementSupplier.name }}</app-badge>
            </div>
          </li>
          <li>
            <div class="flex items-center justify-between gap-2">
              <span class="text-gray-600">Funding source</span>
              <app-badge size="sm">
                <template #prefixIcon>
                  <country-flag
                    :country-code="statementFundingSource?.country_code"
                    class="w-4 h-4"
                  />
                </template>
                {{ statementFundingSourceLabel }}
              </app-badge>
            </div>
          </li>
        </ul>

        <form-kit
          type="form"
          id="new-statement-form"
          :actions="false"
          :incomplete-message="false"
          autocomplete="off"
          form-class="space-y-1.5"
          @submit="handleSubmit"
        >
          <form-kit
            type="date-picker"
            name="dates"
            label="Date range"
            placeholder="Select dates"
            v-model="form.dates"
            validation="required"
            :range="true"
          />
        </form-kit>
      </app-card>
    </div>
  </div>
</template>

<script setup>
import { computed, inject, reactive } from 'vue';
import { FundingSourceTransferMethodLabels } from '@/constants/funding-sources.js';
import { submitForm } from '@formkit/vue';

const emit = defineEmits(['click:back']);

const form = reactive({
  dates: [],
});

const statement = inject('statement');
const statementSupplier = computed(() => statement?.value?.suppliers[0] || {});
const statementFundingSource = computed(() => statement?.value?.funding_source || {});
const fundingSourceTransferMethod = computed(
  () => FundingSourceTransferMethodLabels[statementFundingSource.value?.transfer_method]
);
const statementFundingSourceLabel = computed(
  () => `${statementFundingSource.value?.currency_alpha_code} - ${fundingSourceTransferMethod.value}`
);

const triggerSubmit = () => {
  submitForm('new-statement-form');
};

const handleSubmit = () => {
  emit('create-statement', {
    start_date: form.dates[0],
    end_date: form.dates[1],
    supplier_ids: [statement.value.suppliers[0].id],
    funding_source_id: statement.value.funding_source.id,
  });
};

defineExpose({
  triggerSubmit,
});
</script>
